export interface Contestant {
  id: string;
  alias: string;
  camp: string;
  avatar: string;
  heat: number;
  worksCount: number;
  signature: string;
  intro: string;
  bestWork: string;
}

export const contestants: Contestant[] = [
  {
    id: 'c-01',
    alias: '夜航船',
    camp: '夜班组',
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20portrait%20texture%2C%20crumpled%20paper%20and%20ink%20bleed%2C%20deep%20crimson%20and%20antique%20gold%20tones%2C%20geometric%20silhouette%20without%20recognizable%20face%2C%20no%20text%2C%20no%20people%2C%20minimal%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=400&height=400&seq=cast-01&orientation=squarish',
    heat: 96,
    worksCount: 14,
    signature: '时间线控 / 现场流',
    intro: '擅长把混乱的现场片段按分钟重新排序，代表作多为直播复盘。写作节奏快，喜欢用具体时间点说话。',
    bestWork: '直播翻车名场面三分钟回顾',
  },
  {
    id: 'c-02',
    alias: '雾里看花',
    camp: '冷读组',
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20portrait%20texture%2C%20crumpled%20paper%20and%20ink%20bleed%2C%20deep%20crimson%20and%20antique%20gold%20tones%2C%20geometric%20silhouette%20without%20recognizable%20face%2C%20no%20text%2C%20no%20people%2C%20minimal%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=400&height=400&seq=cast-02&orientation=squarish',
    heat: 93,
    worksCount: 12,
    signature: '长文盘点 / 冷静派',
    intro: '偏好长文与证据分级，几乎不在作品里下结论，而是把矛盾点摆出来让读者自己判断。番外类内容写得尤其松弛。',
    bestWork: '选秀后台录音流出？一份时间线把前因后果理清楚',
  },
  {
    id: 'c-03',
    alias: '铜雀台',
    camp: '行业组',
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20portrait%20texture%2C%20crumpled%20paper%20and%20ink%20bleed%2C%20deep%20crimson%20and%20antique%20gold%20tones%2C%20geometric%20silhouette%20without%20recognizable%20face%2C%20no%20text%2C%20no%20people%2C%20minimal%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=400&height=400&seq=cast-03&orientation=squarish',
    heat: 90,
    worksCount: 11,
    signature: '商务视角 / 表格党',
    intro: '喜欢用表格和逐条对比来讲事情，关注合同、报价、版权这些行业细节，作品对从业者更实用。',
    bestWork: '商务报价单疑云：同一场活动出现两份价目表',
  },
  {
    id: 'c-04',
    alias: '拾荒者',
    camp: '数据组',
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20portrait%20texture%2C%20crumpled%20paper%20and%20ink%20bleed%2C%20deep%20crimson%20and%20antique%20gold%20tones%2C%20geometric%20silhouette%20without%20recognizable%20face%2C%20no%20text%2C%20no%20people%2C%20minimal%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=400&height=400&seq=cast-04&orientation=squarish',
    heat: 87,
    worksCount: 10,
    signature: '数据观察 / 方法论',
    intro: '作品里一定会公开取样方式与判定标准，主张「先给方法再给结论」，因此经常被人拿去验证别的账号。',
    bestWork: '数据注水实锤合集：点赞曲线背后的异常拐点',
  },
  {
    id: 'c-05',
    alias: '白夜行',
    camp: '现场组',
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20portrait%20texture%2C%20crumpled%20paper%20and%20ink%20bleed%2C%20deep%20crimson%20and%20antique%20gold%20tones%2C%20geometric%20silhouette%20without%20recognizable%20face%2C%20no%20text%2C%20no%20people%2C%20minimal%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=400&height=400&seq=cast-05&orientation=squarish',
    heat: 84,
    worksCount: 9,
    signature: '现场还原 / 观众视角',
    intro: '擅长汇总不同座位观众的回忆，交叉印证后再落笔，还原类作品口碑稳定。',
    bestWork: '综艺剪辑之争：被删掉的七分钟到底拍了什么',
  },
  {
    id: 'c-06',
    alias: '冷焰火',
    camp: '造型组',
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20portrait%20texture%2C%20crumpled%20paper%20and%20ink%20bleed%2C%20deep%20crimson%20and%20antique%20gold%20tones%2C%20geometric%20silhouette%20without%20recognizable%20face%2C%20no%20text%2C%20no%20people%2C%20minimal%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=400&height=400&seq=cast-06&orientation=squarish',
    heat: 80,
    worksCount: 8,
    signature: '造型解析 / 风格对照',
    intro: '从红毯与舞台造型切入，习惯用阶段对照来说明变化，很少直接评价人，只谈风格与团队。',
    bestWork: '造型团队集体出走事件始末',
  },
  {
    id: 'c-07',
    alias: '青灯客',
    camp: '音乐组',
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20portrait%20texture%2C%20crumpled%20paper%20and%20ink%20bleed%2C%20deep%20crimson%20and%20antique%20gold%20tones%2C%20geometric%20silhouette%20without%20recognizable%20face%2C%20no%20text%2C%20no%20people%2C%20minimal%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=400&height=400&seq=cast-07&orientation=squarish',
    heat: 76,
    worksCount: 7,
    signature: '听感记录 / 版本比对',
    intro: '偏专业向，作品里常附时间code方便对照试听，措辞谨慎，喜欢用制表方式归档差异。',
    bestWork: '一首歌两个版本：原demo与最终成品的差异盘点',
  },
  {
    id: 'c-08',
    alias: '半糖去冰',
    camp: '取证组',
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20portrait%20texture%2C%20crumpled%20paper%20and%20ink%20bleed%2C%20deep%20crimson%20and%20antique%20gold%20tones%2C%20geometric%20silhouette%20without%20recognizable%20face%2C%20no%20text%2C%20no%20people%2C%20minimal%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=400&height=400&seq=cast-08&orientation=squarish',
    heat: 73,
    worksCount: 7,
    signature: '截图核实 / 去伪存真',
    intro: '专注截图类素材的核实与重排，作品语气偏取证，不讲情绪，只讲顺序。',
    bestWork: '群聊截图时间线整理：谁先说了那句话',
  },
  {
    id: 'c-09',
    alias: '远山雾',
    camp: '现场组',
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20portrait%20texture%2C%20crumpled%20paper%20and%20ink%20bleed%2C%20deep%20crimson%20and%20antique%20gold%20tones%2C%20geometric%20silhouette%20without%20recognizable%20face%2C%20no%20text%2C%20no%20people%2C%20minimal%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=400&height=400&seq=cast-09&orientation=squarish',
    heat: 70,
    worksCount: 6,
    signature: '流程复盘 / 技术视角',
    intro: '从流程表和制作习惯出发解释现场现象，作品常常把「看起来像事故」的事情还原成技术问题。',
    bestWork: '颁奖夜冷场细节复盘：镜头之外发生了什么',
  },
  {
    id: 'c-10',
    alias: '无名氏',
    camp: '冷静组',
    avatar:
      'https://readdy.ai/api/search-image?query=Abstract%20editorial%20portrait%20texture%2C%20crumpled%20paper%20and%20ink%20bleed%2C%20deep%20crimson%20and%20antique%20gold%20tones%2C%20geometric%20silhouette%20without%20recognizable%20face%2C%20no%20text%2C%20no%20people%2C%20minimal%20magazine%20cover%20aesthetic%2C%20high%20detail%2C%20soft%20film%20grain&width=400&height=400&seq=cast-10&orientation=squarish',
    heat: 67,
    worksCount: 6,
    signature: '声明对照 / 公关视角',
    intro: '喜欢把各方公开表态按时间整理成对照表，提醒读者区分商业决策与情绪表达。',
    bestWork: '代言解约风波全记录：从热搜到工作室声明',
  },
];